// src/components/cms/useCms.js
import { useEffect, useMemo, useState } from "react";
import api from "../../api/api";

export function useCms(keys = [], locale = "") {
  const [values, setValues] = useState({});
  const [types, setTypes] = useState({});
  const [loading, setLoading] = useState(false);

  const qp = useMemo(() => {
    const params = new URLSearchParams();
    params.set("keys", keys.join(","));
    if (locale) params.set("locale", locale);
    return params.toString();
  }, [keys, locale]);

  useEffect(() => {
    let mounted = true;
    (async () => {
      if (!keys.length) return;
      setLoading(true);
      try {
        const { data } = await api.get(`/cms?${qp}`);
        if (!mounted) return;
        const v = {}, t = {};
        keys.forEach((k) => {
          v[k] = data?.[k]?.value ?? "";
          t[k] = data?.[k]?.type ?? "text";
        });
        setValues(v);
        setTypes(t);
      } finally {
        setLoading(false);
      }
    })();
    return () => { mounted = false; };
  }, [qp, keys]);

  const setValue = (key, val) => setValues((s) => ({ ...s, [key]: val }));

  const save = async () => {
    const entries = keys.map((k) => ({
      key: k,
      value: values[k] ?? "",
      type: types[k] || "text",
      locale: locale || null,
    }));
    await api.post("/admin/cms", { entries });
  };

  return { values, setValue, types, setTypes, loading, save };
}
